import { Form, Formik } from "formik";
// import { withFormikDevtools } from "formik-devtools-extension";
import { object, ref, string } from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { InputField } from "components";
import { changePassword } from "store/authentication/authentication.slice";

import "components/form/FormikForm.scss";

const ChangePasswordForm = () => {
  const { t } = useTranslation("registration", { useSuspense: false });
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const Validation = object().shape({
    current_password: string()
      .min(8, t("najmanje_8_cifara"))
      .max(32, "Maksimalna dužina lozinke može biti 32 karaktera")
      .required(t("unesite_lozinku")),
    new_password: string()
      .min(8, t("najmanje_8_cifara"))
      .max(32, "Maksimalna dužina lozinke može biti 32 karaktera")
      .required(t("unesite_lozinku")),
    confirm_password: string()
      .label(t("potvrdite_lozinku"))
      .required(t("potvrdite_lozinku"))
      .oneOf([ref("new_password"), ""], t("lozinke_se_moraju_poklapati")),
  });

  const handleSubmit = (values: any, { setSubmitting }: any) => {
    dispatch(changePassword(values)).then(() => {
      setSubmitting(false);
      navigate("/profile");
    });
  };

  return (
    <div className="Form-Box">
      <div className="Form">
        <h2>Promjeni lozinku</h2>
        <Formik
          initialValues={{
            current_password: "",
            new_password: "",
            confirm_password: "",
          }}
          validationSchema={Validation}
          onSubmit={handleSubmit}
        >
          {(
            //   formikProps.values,
            //   formikProps.errors,
            //   formikProps.touched,
            //   formikProps.handleChange,
            //   formikProps.handleBlur,
            //   formikProps.handleSubmit,
            // formikProps.isSubmitting,
            formikProps
          ) => (
            // withFormikDevtools(
            //   formikProps,
            <Form className="Formik-Form">
              <InputField
                name="current_password"
                label="Trenutna lozinka"
                type="password"
                required={true}
              />
              <InputField
                name="new_password"
                label="Nova lozinka"
                type="password"
                required={true}
              />
              <InputField
                name="confirm_password"
                label={t("ponovljena_lozinka")}
                type="password"
                required={true}
              />
              <button
                type="submit"
                disabled={formikProps.isSubmitting}
                className="Form-Button"
              >
                {t("potvrdi")}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
export default ChangePasswordForm;
